// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2JPU7","footer":"ModalError_footer__2X8Kt"};